$(function(){
	$('.js-open-search').on('click', function(){
		var $parent = $(this).parent();
		$parent.toggleClass('open');
		$('.js-navigation').toggleClass('open');
		$('.js-language-switcher').toggleClass('open');
		$('.js-main-nav').toggleClass('open');
		$('.js-right-menu').toggleClass('open');

		if ($parent.is('.open')) {
			$parent.find('input').first().focus();
		} else {
			$parent.find('input').first().focusout();
		}

	});
});
